import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Cookie } from 'lucide-react';

const STORAGE_KEY = 'owl_cookie_consent';

const CookieConsent = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(STORAGE_KEY)) setShow(true);
    } catch (e) {
      /* storage unavailable — do not show, do not load analytics */
    }
  }, []);

  const decide = (accepted) => {
    try {
      localStorage.setItem(STORAGE_KEY, accepted ? 'accepted' : 'rejected');
    } catch (e) {}
    if (accepted && typeof window.owlLoadAnalytics === 'function') {
      window.owlLoadAnalytics();
    }
    setShow(false);
  };

  if (!show) return null;

  return (
    <div
      role="dialog"
      aria-live="polite"
      aria-label="Cookie consent"
      className="fixed inset-x-0 bottom-0 z-[70] px-4 pb-4 sm:px-6 sm:pb-6"
      data-testid="cookie-consent"
    >
      <div className="max-w-3xl mx-auto rounded-2xl border border-slate-700 bg-slate-900/95 backdrop-blur-xl shadow-2xl p-5 sm:p-6">
        <div className="flex flex-col sm:flex-row sm:items-center gap-4">
          <div className="flex items-start gap-3 flex-1">
            <Cookie className="w-5 h-5 text-slate-300 flex-shrink-0 mt-0.5" />
            <p className="text-sm text-slate-300 leading-relaxed">
              We use strictly necessary cookies to run this site, and optional analytics to understand usage.
              Optional analytics only load if you accept. See our{' '}
              <Link to="/privacy" className="text-white underline hover:text-slate-200">Privacy Policy</Link>.
            </p>
          </div>
          <div className="flex items-center gap-3 flex-shrink-0">
            <button
              onClick={() => decide(false)}
              className="px-5 py-2.5 rounded-full text-sm font-medium text-slate-300 border border-slate-600 hover:border-slate-400 hover:text-white transition-colors"
              data-testid="cookie-reject"
            >
              Reject
            </button>
            <button
              onClick={() => decide(true)}
              className="px-5 py-2.5 rounded-full text-sm font-semibold text-slate-900 bg-white hover:bg-slate-100 transition-colors"
              data-testid="cookie-accept"
            >
              Accept
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
